export const FILTER_BY_CATEGORY = 'filter/category';
export const FILTER_BY_AUTHOR =  'filter/author';
export const FILTER_BY_SEARCH =  'filter/search';
export const CLEAR_SEARCH_TERM = 'search/clear_searchTerm'